export const ADMIN_STATS_REQUEST = "ADMIN_STATS_REQUEST";
export const ADMIN_STATS_SUCCESS = "ADMIN_STATS_SUCCESS";
export const ADMIN_STATS_FAIL = "ADMIN_STATS_FAIL";

export const ADMIN_STORES_REQUEST = "ADMIN_STORES_REQUEST";
export const ADMIN_STORES_SUCCESS = "ADMIN_STORES_SUCCESS";
export const ADMIN_STORES_FAIL = "ADMIN_STORES_FAIL";

export const ADMIN_STORE_MUTATE_REQUEST = "ADMIN_STORE_MUTATE_REQUEST";
export const ADMIN_STORE_MUTATE_SUCCESS = "ADMIN_STORE_MUTATE_SUCCESS";
export const ADMIN_STORE_MUTATE_FAIL = "ADMIN_STORE_MUTATE_FAIL";
export const ADMIN_STORE_MUTATE_RESET = "ADMIN_STORE_MUTATE_RESET";

export const ADMIN_USERS_REQUEST = "ADMIN_USERS_REQUEST";
export const ADMIN_USERS_SUCCESS = "ADMIN_USERS_SUCCESS";
export const ADMIN_USERS_FAIL = "ADMIN_USERS_FAIL";

export const ADMIN_USER_MUTATE_REQUEST = "ADMIN_USER_MUTATE_REQUEST";
export const ADMIN_USER_MUTATE_SUCCESS = "ADMIN_USER_MUTATE_SUCCESS";
export const ADMIN_USER_MUTATE_FAIL = "ADMIN_USER_MUTATE_FAIL";
export const ADMIN_USER_MUTATE_RESET = "ADMIN_USER_MUTATE_RESET";

export const PRICE_BOOK_REQUEST = "PRICE_BOOK_REQUEST";
export const PRICE_BOOK_SUCCESS = "PRICE_BOOK_SUCCESS";
export const PRICE_BOOK_FAIL = "PRICE_BOOK_FAIL";

export const PRICE_BOOK_MUTATE_REQUEST = "PRICE_BOOK_MUTATE_REQUEST";
export const PRICE_BOOK_MUTATE_SUCCESS = "PRICE_BOOK_MUTATE_SUCCESS";
export const PRICE_BOOK_MUTATE_FAIL = "PRICE_BOOK_MUTATE_FAIL";
export const PRICE_BOOK_MUTATE_RESET = "PRICE_BOOK_MUTATE_RESET";

export const PRICE_BOOK_IMPORT_REQUEST = "PRICE_BOOK_IMPORT_REQUEST";
export const PRICE_BOOK_IMPORT_SUCCESS = "PRICE_BOOK_IMPORT_SUCCESS";
export const PRICE_BOOK_IMPORT_FAIL = "PRICE_BOOK_IMPORT_FAIL";
export const PRICE_BOOK_IMPORT_RESET = "PRICE_BOOK_IMPORT_RESET";

export const WHOLESALE_PRICE_BOOK_REQUEST = "WHOLESALE_PRICE_BOOK_REQUEST";
export const WHOLESALE_PRICE_BOOK_SUCCESS = "WHOLESALE_PRICE_BOOK_SUCCESS";
export const WHOLESALE_PRICE_BOOK_FAIL = "WHOLESALE_PRICE_BOOK_FAIL";

export const WHOLESALE_PRICE_BOOK_MUTATE_REQUEST = "WHOLESALE_PRICE_BOOK_MUTATE_REQUEST";
export const WHOLESALE_PRICE_BOOK_MUTATE_SUCCESS = "WHOLESALE_PRICE_BOOK_MUTATE_SUCCESS";
export const WHOLESALE_PRICE_BOOK_MUTATE_FAIL = "WHOLESALE_PRICE_BOOK_MUTATE_FAIL";
export const WHOLESALE_PRICE_BOOK_MUTATE_RESET = "WHOLESALE_PRICE_BOOK_MUTATE_RESET";

export const WHOLESALE_PRICE_BOOK_IMPORT_REQUEST = "WHOLESALE_PRICE_BOOK_IMPORT_REQUEST";
export const WHOLESALE_PRICE_BOOK_IMPORT_SUCCESS = "WHOLESALE_PRICE_BOOK_IMPORT_SUCCESS";
export const WHOLESALE_PRICE_BOOK_IMPORT_FAIL = "WHOLESALE_PRICE_BOOK_IMPORT_FAIL";
export const WHOLESALE_PRICE_BOOK_IMPORT_RESET = "WHOLESALE_PRICE_BOOK_IMPORT_RESET";

export const ADMIN_CLEAR_ERRORS = "ADMIN_CLEAR_ERRORS";
